import { Button, Intent, Size } from "@blueprintjs/core"
import { useState } from "react"
import { ID, POST_STATUS, SORT_TYPE } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import Feed from "src/modules/pe-basic-module/views/core/Feed"
import { ILanding, ILandingSection, ILink, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { isRole } from "src/settings/zustand/user"
import CategorySwitcher from "../../../utils/links-feed/CategorySwitcher"
import { SingleLinkDialog } from "../../landing-edit/editors/link/SingleLinkDialog"
import LinkFeedCard from "./LinkFeedCard"
import actions from "src/modules/pe-basic-module/data/actions"
import { DELETE_SINGLE_TYPE, UPDATE_SINGLE_TYPE } from "src/modules/pe-basic-module/data/actionTypes" 

/* Protopia Ecosystem component */
export interface IExternalLinkFeedProps {
   section?: ILandingSection
   primitive: LinksFeedContent
}
const ExternalLinkFeed = (props: IExternalLinkFeedProps): JSX.Element => {
    const currentLanding: ILanding      = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const linkFeedCategories: ID[]      = useLandingConsoleStore( (state: ILandingConsoleStore) => state.linkFeedCategories )
    const isEdit                        = useLandingStore((state: ILandingStore) => state.isEdit ) 
    
    const getCategoriesIds = () => {
        return  props.primitive.categoryId || 
        ( !!linkFeedCategories?.length ? linkFeedCategories : currentLanding.categories?.map(c => c.id) ) || 
        []
    }  

    const onItemChange = (value: any, field: string, item: ILink ) => {
        
        console.log( value, field, item )
        
        switch( field)
        {
            case "status":
                field = "post_status"
                break
            case "description":
                field = "post_content"
                break 
        }
        actions(
            UPDATE_SINGLE_TYPE,
            {
                data_type: "PELink",
                item: {
                    [field]: value
                },
                id: item.id
            }
        )
        .then( res => {
            setSeed(  Math.random() + ""  )
        })
    }
    const onAdd = (data: ILink, id?: ID) => {
        console.log(data) 
        let item = {
            ...data,
            post_status: data.status || data.post_status,
            post_content: data.description || data.post_content,
        }
        delete item.id
        delete item.__typename
        delete item.status
        delete item.description
        
        console.log( item )
        
        actions(
            UPDATE_SINGLE_TYPE,
            {
                data_type: "PELink",
                item,
                id, 
            }
        )
        .then( res => {
            setSeed(  Math.random() + ""  )
        })
        setIsOpen( false )
    }

    const [ sorts, setSort ]            = useState<(SORT_TYPE)[]>([ SORT_TYPE.ORDER ])
    const [ status, setStatus ]         = useState<POST_STATUS>( POST_STATUS.PUBLISH )
    const [ allItems, setAllItems ]     = useState<ILink[]>( [] ) 
    const [ fullCount, setFullCount ]   = useState<number>( 0 ) 
    const [ isOpen, setIsOpen ]         = useState<boolean>( false ) 
    const [ distination, setDistination ] = useState<"UP" | "DOWN">( "DOWN" )  
    const [ categories, setCategories ] = useState<ID[]>( getCategoriesIds() )
    const [ seed, setSeed ] = useState<string>( Math.random() + "" )
    const [ offset, setOffset ] = useState<number | undefined>( undefined )

    const getPaging = ( dist?: "UP" | "DOWN", sortType?: SORT_TYPE, status?: POST_STATUS, termSlugs?: ID[] ): string => {
        // taxonomies
        let taxonomies: string = !termSlugs ? "" : `taxonomies:[{tax_name: "pelandingcategory", term_slugs: [ "${( termSlugs || [] ).join( '","' )}" ] }], `;

        // order by meta
        let order_by_meta = ''
        switch(sortType) {
            case SORT_TYPE.ORDER:
            case SORT_TYPE.RATING:
                order_by_meta = ``
                break
            case SORT_TYPE.ALPHABET:
                order_by_meta = `order_by_meta: "title",`
                break
            default:
                order_by_meta = ``
        }
        // status
        let _status = ` metas: [ {key: "post_status", value: "${ status || POST_STATUS.PUBLISH }"} ], `
         
        // order
        let order: string = ``
        switch(dist) {
            case "DOWN":
                order = ` order: "DESC" `
                break
            case "UP":
                order = ` order: "ASC" `
                break
            default:
                order = ` order: "DESC" `
        }
        return `${taxonomies} ${_status} ${ order_by_meta } ${ order } `
    }
    const [paging, setPaging]           = useState<string>( getPaging(  distination, sorts[ 0 ], status, categories ) )


    const onCategories = (categories: ID[]) => {
        setCategories( categories )
        useLandingConsoleStore.setState({ linkFeedCategories : categories })
        setOffset( 0 )
        setPaging(
            getPaging( 
                distination,
                sorts[ 0 ],
                status,
                categories
            )
        )
    }
    const onStatus = (_status: POST_STATUS) => {
        setOffset( 0 )
        setStatus( _status )
        setPaging(
            getPaging( 
                distination,
                sorts[ 0 ],
                _status,
                categories
            )
        )
    }
    const onDistination = (dist: "UP" | "DOWN") => {
        setDistination( dist )
        setOffset( undefined )
        setPaging(
            getPaging( 
                dist,
                sorts[ 0 ],
                status,
                categories
            )
        )
    }
    const onSortTypes = ( sortTypes: SORT_TYPE[] ) => {
        setSort( sortTypes ) 
        setPaging(
            getPaging( 
                distination,
                sortTypes[0],
                status,
                categories
            )
        )
    } 
    const onLoading = (items: any[],  offset: number, count: number, paging: string, fullCount: number) => {
        setAllItems( items )
        setFullCount(fullCount) 
        setOffset( offset )
    }

    const doDelete = (item: ILink ) => {
        actions(
            DELETE_SINGLE_TYPE,
            {
                id: item.id,
                data_type: "PELink"
            }
        )
        .then( res => {
            setSeed(  Math.random() + ""  )
        })
    }
    
    return <div className='pe-external-link-feed-container'>
        <div className="lead mb-2" dangerouslySetInnerHTML={{ __html: props.primitive.title || "" }} /> 
        <CategorySwitcher 
            status={status} 
            primitive={ props.primitive } 
            items={ allItems } 
            fullCount={fullCount}
            categories={ categories } 
            onCategories={ onCategories } 
            onStatus={onStatus} 
            onDistination={ onDistination }
            onSortTypes={onSortTypes}
            distination={distination}
            sorts={ sorts }
        />  
        {
            ( isEdit || isRole([ "administrator" ])) && props.primitive.isAdd && <div className="my-4">
                <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0 " icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                    <div className="smaller">
                        {__( "Add" )}
                    </div>
                </Button> 
                <SingleLinkDialog value={{} as ILink} isOpen={ isOpen } onClose={()=>setIsOpen( false )} onAdd={ onAdd } /> 
            </div>
        } 
        <Feed
            data_type="PELink"
            component={ LinkFeedCard }
            topPagiHide={ !props.primitive.isTopPagination }
            // bottomPagiHide={ !props.primitive.isBottomPaging }
            paging={ paging }
            offset={ offset }
            class_name="row w-100" 
            containerClassName="container-fluid"
            onLoading={ onLoading }
            params={{
                seed,
                col: props.primitive.columns ,
                primitive: props.primitive,
                items: allItems,
                section: props.section,
                onChange: onItemChange,
                doDelete,
                onAdd
            }}
        />
        {
            (isEdit || isRole([ "administrator" ])) && props.primitive.isAdd && <div className="my-4">
                <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0" icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                    <div className="smaller">
                        {__( "Add" )}
                    </div>
                </Button> 
            </div>
        }
    </div>
}
export default ExternalLinkFeed